'use client'

import { useState } from 'react'
import { Globe } from 'lucide-react'
import { Language } from '@/lib/brief613/translations'
import { ghostBtn, modalPanel } from './ui'

interface LanguageSwitcherProps {
  currentLanguage: Language
  onLanguageChange: (lang: Language) => void
}

const languages: { code: Language; name: string; flag: string }[] = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
]

export default function LanguageSwitcher({ currentLanguage, onLanguageChange }: LanguageSwitcherProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={ghostBtn}
      >
        <Globe size={14} />
        <span className="text-sm">{languages.find((l) => l.code === currentLanguage)?.flag}</span>
        <span className="hidden md:inline">
          {languages.find((l) => l.code === currentLanguage)?.name}
        </span>
      </button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className={`absolute right-0 mt-2 w-48 ${modalPanel} z-50 overflow-hidden`}>
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  onLanguageChange(lang.code)
                  setIsOpen(false)
                }}
                className={`w-full text-left px-4 py-2.5 hover:bg-white/5 transition-colors flex items-center gap-3 text-xs ${
                  currentLanguage === lang.code ? 'bg-white/[0.06] text-white/90 font-medium' : 'text-white/70'
                }`}
              >
                <span className="text-base">{lang.flag}</span>
                <span>{lang.name}</span>
                {currentLanguage === lang.code && (
                  <span className="ml-auto text-white/70">✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
